import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-23" data-mp="2atgxme8bxy3c">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-24" data-mp="38b8nm837wooy">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-white shadow-[0_12px_30px_-6px_rgba(14,21,36,0.45)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-ctadark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-25" data-mp="3342jzpksle1i">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-26" data-mp="2kctd7o2ep3dm" />
            <span className="text-[16px] font-extrabold uppercase tracking-wide" data-id="element-27" data-mp="2kaowu6nbmbwg">Get it now for $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}